import { LoaderFunctionArgs } from "react-router-dom";
import {apiEndpoints} from "@/services/api/api.ts";
import {AdminPanelTagData} from "@/routes/adminPanel/tags/main/types/adminPanelTagData.ts";

export async function adminPanelTagEditLoader({
                                                  params,
                                              }: LoaderFunctionArgs): Promise<AdminPanelTagData> {
    try {
        if (!params.tagId) {
            return {} as AdminPanelTagData;
        }

        const response = await apiEndpoints.getTagById(params.tagId);
        return response.data;
    } catch (error) {
        throw new Error(error instanceof Error ? error.message : "Unknown error");
    }
}